import { Alert, ButtonText, Spacer, Typography, Grid } from '@percent/lemonade'
import { config } from '@percent/cause-dashboard/config'
import styles from './DonationFormPage.module.scss'
import { useAuthState } from '@percent/cause-dashboard/common/hooks/useAuthState/useAuthState'
import { Code } from '@percent/cause-dashboard/common/components'
import { useCausesPortalAnalytics } from '@percent/cause-dashboard/common/hooks/useCausesDashboardAnalytics/useCausesDashboardAnalytics'
import { DonationFormEventName } from '@percent/cause-dashboard/common/hooks/useCausesDashboardAnalytics/causeDashboardAnalytics.types'
import { t } from 'i18next'
import { DONATION_FORM_HELP_LINK } from '@percent/cause-dashboard/constants/support'

export const EmbeddedSnippetTab = () => {
  const {
    authState: { user, organisation }
  } = useAuthState()
  const { track } = useCausesPortalAnalytics()

  const donationWidgetScript = `<script defer src="${config.urls.donationWidget}"></script>`

  const buttonScript = `<div id="pbp-donation-widget"
  data-link-id="${config.ids.donationLink}"
  data-organisation-id="${user?.organisationId}" />`

  const handleCopyButtonScript = () => {
    track(DonationFormEventName.ADD_DONATE_BUTTON, {
      orgId: organisation?.id,
      accountEmail: user?.email,
      country: organisation?.countryCode
    })
  }

  const handleCopyLoaderScript = () => {
    track(DonationFormEventName.LOAD_GOODSTACK_LIBRARY, {
      orgId: organisation?.id,
      accountEmail: user?.email,
      country: organisation?.countryCode
    })
  }

  return (
    <Grid className={styles.grid} data-testid="embedded-snippet-tab">
      <Grid.Col span={{ xs: 12 }} className={styles.gridItem}>
        <Spacer size="m" axis="horizontal" />
        <Typography variant="h3" data-testid="embedded-snippet-heading">
          {t('donationForm.embedSnippet.goodstackLoader.heading')}
        </Typography>
        <Spacer size="m" axis="horizontal" />
        <Alert variant="info" title={t('donationForm.embedSnippet.alert.title')} />
        <Spacer size="m" axis="horizontal" />
        <Typography className={styles.description} data-testid="embedded-snippet-description">
          {t('donationForm.embedSnippet.goodstackLoader.description')}
        </Typography>
        <Spacer size={24} axis="horizontal" />
        <Code
          code={donationWidgetScript}
          language="html"
          wordWrap={true}
          onCopy={handleCopyLoaderScript}
          dataTestId="embedded-snippet-donation-widget-script"
        />
        <Spacer size={24} axis="horizontal" />
        <Typography variant="h3" color="textSecondary" data-testid="embedded-snippet-donate-button-heading">
          {t('donationForm.embedSnippet.donateButton.heading')}
        </Typography>
        <Spacer size={24} axis="horizontal" />
        <Typography className={styles.description} data-testid="embedded-snippet-donate-button-description">
          {t('donationForm.headerTab.embedSnippet.donateButton.description')}
        </Typography>
        <Spacer size="m" axis="horizontal" />
        <Code
          code={buttonScript}
          language="html"
          wordWrap={true}
          onCopy={handleCopyButtonScript}
          dataTestId="embedded-snippet-button-script"
        />
        <Spacer size={24} axis="horizontal" />
        <Typography variant="h3" color="textSecondary" data-testid="embedded-snippet-other-platforms-button-heading">
          {t('donationForm.embedSnippet.otherPlatforms.heading')}
        </Typography>
        <Spacer size={24} axis="horizontal" />
        <Typography
          className={styles.description}
          color="textSecondary"
          data-testid="embedded-snippet-other-platforms-description"
        >
          {t('donationForm.embedSnippet.otherPlatforms.description')}
        </Typography>
        <Spacer size="m" axis="horizontal" />
        <ButtonText
          variant="primary"
          icon="external-link"
          onClick={() => window.open(DONATION_FORM_HELP_LINK, '_blank')}
          children={t('donationForm.embedSnippet.otherPlatforms.button')}
          data-testid="embedded-snippet-other-platforms-button"
        />
      </Grid.Col>
    </Grid>
  )
}
